import { render, staticRenderFns } from "./short-code-wizard.vue?vue&type=template&id=c345a0c8"
import script from "./short-code-wizard.vue?vue&type=script&lang=js"
export * from "./short-code-wizard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports